import * as api from "../../api/index";
import * as endpoints from "../../api/endpoints";
import * as types from "../../mutation-types";

const actions = {
  getWorkMachines({ commit }, payload) {
    return api.fetch(endpoints.WORK_MACHINES, payload, commit, (response) => {
      commit(types.SET_WORK_MACHINES, response.data.data);
    });
  },
  getWorkMachineEquipments({ commit }, payload) {
    return api.fetch(endpoints.WORK_MACHINE_EQUIPMENTS, payload, commit, (response) => {});
  },
  getWorkMachineExpirationDocumentTypes({ commit }, payload) {
    return api.fetch(endpoints.WORK_MACHINE_EXPIRATION_DOCUMENT_TYPES, payload, commit, (response) => {});
  },
  getWorkMachine({ commit }, payload) {
    return api.fetch(endpoints.WORK_MACHINES + "/" + payload.uuid, payload, commit, (response) => {
      commit(types.SET_WORK_MACHINE, response.data);
    });
  },
  createWorkMachine({ commit }, payload) {
    return api.post(endpoints.WORK_MACHINES, payload, commit, (response) => {});
  },
  updateWorkMachine({ commit }, payload) {
    return api.put(endpoints.WORK_MACHINES + "/" + payload.uuid, payload, commit, (response) => {
      commit(types.SET_WORK_MACHINE, response.data);
      commit("common/" + types.SET_PAGINATION, response.data.pagination, { root: true });
    });
  },
  deleteWorkMachine({ commit }, payload) {
    return api.remove(endpoints.WORK_MACHINES + "/" + payload.uuid, payload, commit, (response) => {
      commit(types.SET_WORK_MACHINE, response.data);
      commit("common/" + types.SET_PAGINATION, response.data.pagination, { root: true });
    });
  },
  getWorkMachineCostTypes({ commit }, payload) {
    return api.fetch(endpoints.WORK_MACHINE_COST_TYPES, payload, commit, (response) => {
      commit(types.SET_WORK_MACHINE_COST_TYPES, response.data ?? []);
    });
  },
  getWorkMachineCosts({ commit }, payload) {
    return api.fetch(endpoints.WORK_MACHINE_COSTS, payload, commit, (response) => {
      commit(types.SET_WORK_MACHINE_COSTS, response.data.data ?? []);
      if (response.data.pagination) {
        commit("common/" + types.SET_PAGINATION, response.data.pagination, { root: true });
      }
    });
  },
  getWorkMachineCost({ commit }, payload) {
    return api.fetch(endpoints.WORK_MACHINE_COSTS + "/" + payload.uuid, payload, commit, (response) => {
      commit(types.SET_WORK_MACHINE_COST, response.data ?? {});
    });
  },
  getWorkMachineCostsCombined({ commit }, payload) {
    return api.fetch(endpoints.WORK_MACHINE_COSTS_COMBINED, payload, commit, () => {});
  },
  createWorkMachineCost({ commit }, payload) {
    return api.post(endpoints.WORK_MACHINE_COSTS, payload, commit, (response) => {
      commit(types.SET_WORK_MACHINE_COST, response.data ?? {});
    });
  },
  updateWorkMachineCost({ commit }, payload) {
    return api.put(endpoints.WORK_MACHINE_COSTS + "/" + payload.uuid, payload, commit, (response) => {
      commit(types.SET_WORK_MACHINE_COST, response.data ?? {});
    });
  },
  deleteWorkMachineCost({ commit }, payload) {
    return api.remove(endpoints.WORK_MACHINE_COSTS + "/" + payload.uuid, payload, commit, (response) => {
      commit(types.SET_WORK_MACHINE_COST, response.data ?? {});
    });
  },
};

export default actions;
